// Reprise sur échec transitoire des appels à l'API du portail.
//
// Incident 2026-09-09 : le portail a servi 15 079 réponses 5xx sur la journée
// (3,7 % du trafic), dont 22 sur les endpoints RDV publics. Ces 502/504 sont
// émis par le proxy SANS traverser FastAPI, donc SANS en-tête
// Access-Control-Allow-Origin : le navigateur rejette la réponse et fetch()
// lève un TypeError « Failed to fetch », qui s'affichait tel quel au visiteur.
//
// Deux corrections en une : on retente les échecs transitoires (l'API répond en
// ~80 ms le reste du temps, une seconde tentative aboutit presque toujours), et
// on ne laisse jamais remonter un message technique anglais jusqu'à l'écran.

const MESSAGE_VISITEUR =
  "Le service est momentanément indisponible. Merci de réessayer dans un instant.";

const attendre = (ms) =>
  ms > 0 ? new Promise((r) => setTimeout(r, ms)) : Promise.resolve();

// Un échec réseau (hôte injoignable, TLS, réponse sans CORS) se présente en
// TypeError. Une erreur applicative 4xx, elle, est définitive : la retenter ne
// ferait que marteler le serveur.
const estTransitoire = (erreur) =>
  erreur instanceof TypeError || erreur.status >= 500;

/**
 * GET JSON avec reprise sur échec transitoire.
 *
 * @param {string} url
 * @param {{headers?: object, retries?: number, delayMs?: number}} options
 *        retries : tentatives SUPPLÉMENTAIRES après la première (défaut 2).
 *        delayMs : attente avant la 2e tentative, doublée ensuite (défaut 500).
 * @returns {Promise<object>} le JSON de la réponse
 * @throws {Error} message destiné au visiteur si l'échec persiste
 */
export async function fetchJsonWithRetry(url, options = {}) {
  const { headers, retries = 2, delayMs = 500 } = options;
  let derniere;

  for (let tentative = 0; tentative <= retries; tentative += 1) {
    try {
      const r = await fetch(url, headers ? { headers } : undefined);
      if (!r.ok) {
        const err = new Error(`HTTP ${r.status}`);
        err.status = r.status;
        throw err;
      }
      return await r.json();
    } catch (e) {
      derniere = e;
      if (!estTransitoire(e)) throw e;
      if (tentative < retries) await attendre(delayMs * 2 ** tentative);
    }
  }

  const err = new Error(MESSAGE_VISITEUR);
  err.cause = derniere;
  err.status = derniere?.status;
  throw err;
}
